import { Component, DestroyRef, OnInit, ViewContainerRef } from '@angular/core';
import { DialogService } from '@markant-platform/shared/dialog/feature';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { filter, map, pairwise } from 'rxjs';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { initHiddenColumns } from '@markant-platform/shared/data-access';

@Component({
  selector: 'markant-platform-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  static readonly platformTranslationKey = 'platform';

  constructor(
    private readonly snackbarService: SnackbarService,
    private readonly dialogService: DialogService,
    private readonly viewRef: ViewContainerRef,
    private readonly title: Title,
    private readonly translocoService: TranslocoService,
    private readonly router: Router,
    private readonly destroyRef: DestroyRef,
    private readonly store: Store
  ) {
    this.setPlatformTitleSubscriber();
    this.setPlatformTitleAfterFocusView();
    this.initPageTracking();
    this.store.dispatch(initHiddenColumns());
  }

  ngOnInit(): void {
    this.dialogService.appComponentViewRef = this.viewRef;
    this.snackbarService.appComponentViewRef = this.viewRef;
  }

  private setPlatformTitleSubscriber(): void {
    this.translocoService
      .selectTranslate(AppComponent.platformTranslationKey)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(translatedTitle => this.title.setTitle(translatedTitle));
  }

  private setPlatformTitleAfterFocusView(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof RoutesRecognized),
        map(event => event as RoutesRecognized),
        pairwise(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(([previous, current]) => {
        if (previous.url.includes('focus-view') && !current.url.includes('focus-view')) {
          const platformTitle = this.translocoService.translate(AppComponent.platformTranslationKey);
          this.title.setTitle(platformTitle);
        }
      });
  }

  private initPageTracking(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        const _jts = (window as { _jts?: unknown[] })._jts;

        if (_jts) {
          _jts.push({ track: 'pageview' });
          _jts.push({ track: 'submit' });
        }
      });
  }
}
